
import swal from 'sweetalert';
export default class Alert {

    static show(title, msg, icon) {
        var popupHtml = document.createElement("div");
        popupHtml.innerHTML = msg;

        swal({
            title: title,
            content: popupHtml,
            icon: icon,
            button: "Ok",
        })
    }

    static showUpgrade(title, msg, icon) {
        var popupHtml = document.createElement("div");
        popupHtml.innerHTML = msg;

        swal({
            title: title,
            content: popupHtml,
            icon: icon,
            buttons: [
                'Cancel',
                'Upgrade'
            ]
        }).then((result) => {
            if (result)
                window.location = "plans"
        })
    }
}